import React, { useState, Dispatch, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setExceptionHandler, removeDetailsBreadcrumb, customBreadcrumbs } from '@app/store/actions';
import { loginForms } from '@app/enums';
import { TwoFactorList } from '@app/modules/mfaToken/components';
import { VerifyUserOtp, VerifyUserPush } from '@app/pages/directoryManager/details/components';
import { useParams } from 'react-router';
import { ManageAccount } from '@app/store/constants';
import { hasOrgPermission } from '@app/helpers';
import { useTypedTranslation } from '@app/hooks';
import { usersService } from '@app/services';

function getComponent(
    providers: string[],
    loginForm: loginForms | null,
    setLoginForm: Dispatch<loginForms>,
    userId: string
) {
    const isMultipleProviders = providers.length > 1;
    switch (loginForm) {
        case loginForms.twoFactorList:
            return <TwoFactorList setLoginForm={setLoginForm} providers={providers} verifyUser={true} />;

        case loginForms.twoFactorOtp:
            return <VerifyUserOtp userId={userId} setLoginForm={setLoginForm} providers={providers} />;

        case loginForms.twoFactorPush:
            return (
                <VerifyUserPush userId={userId} setLoginForm={setLoginForm} isMultipleProviders={isMultipleProviders} />
            );

        default:
            return null;
    }
}

export default function VerifyUser2fa() {
    const [providers, setProviders] = useState<string[]>([]);
    const [loginForm, setLoginForm] = useState<loginForms | null>(null);
    const { id: userId } = useParams<{ id: string }>();

    const dispatch = useDispatch();

    const { translation } = useTypedTranslation();

    useEffect(() => {
        dispatch(setExceptionHandler(true));

        usersService.getUser(userId).then(({ data }) => {
            dispatch(customBreadcrumbs([
                {
                    name: translation('DIRECTORY_MANAGEMENT_APP_NAME')
                },
                {
                    name: translation('USERS'),
                    link: '/directory/users'
                },
                {
                    name: data.DisplayName,
                    link: `/directory/users/details/${userId}`,
                },
                {
                    name: translation('VERIFY_USER')
                }
            ]));
        });       

        usersService.getUser2faOptions(userId).then(({ data }) => {
            setProviders(data.Providers);

            if (data.Providers.length > 1) {
                setLoginForm(loginForms.twoFactorList);
                return;
            }
            switch (data.Providers[0]) {
                case 'otp':
                    setLoginForm(loginForms.twoFactorOtp);
                    break;
                case 'push':
                    setLoginForm(loginForms.twoFactorPush);
                    break;

                default:
                    break;
            }
        });

        return () => {
            dispatch(removeDetailsBreadcrumb());
        };
    }, []);

    return (
        <div className='test-mfa'>
            {hasOrgPermission([ManageAccount]) ?
                <div className='login__wrapper'>
                    <div className='login__container'>
                        {getComponent(providers, loginForm, setLoginForm, userId)}
                    </div>
                </div>
                :
                <div className='table--empty'>{translation('VERIFY_USER_NO_PERMISSION')}</div>
            }
        </div>
    );
}
